import type { MailMessageSummary } from "@/lib/types/mail";

export function mergeOutboxSummaries(
  scheduled: MailMessageSummary[],
  queue: MailMessageSummary[]
): MailMessageSummary[] {
  return [...scheduled, ...queue];
}

export function outboxTotalCount(scheduledCount: number, queueCount: number): number {
  return scheduledCount + queueCount;
}
